<template>
    <div class="container shipping_conf">
        <div class="panel-body" style="background-color: white">
            <h3>{{ $t('page.mapping.overview')}}</h3>
            <input type="hidden" id="manage-abteilung-hidden" value=""/>
            <div class="table-responsive">
                <button class="btn btn-info btn-left glyphicon" @click="showModal(null)">+</button>
                <table class="table table-responsive">
                    <thead>
                    <th>#</th>
                    <th>{{ $t('page.mapping.name_int')}}</th>
                    <th>{{ $t('page.mapping.name_ext')}}</th>
                    <th>{{ $t('page.shipping.shipper')}}</th>
                    <th>{{ $t('page.shipping.shop')}}</th>
                    </thead>
                    <tbody>
                    <tr v-for="(shippingMethodMapping, index) in shippingMethodMappings">
                        <td>{{index+1}}</td>
                        <td>{{shippingMethodMapping.shippingMethod.name}}</td>
                        <td>{{shippingMethodMapping.name}}</td>
                        <td>{{shippingMethodMapping.shipper.name}}</td>
                        <td>{{shippingMethodMapping.shop.name}}</td>
                        <td>
                            <button class="btn btn-link glyphicon glyphicon-wrench"
                                    @click="showModal(shippingMethodMapping.shippingMethod.id)"></button>
                            <button class="btn btn-link glyphicon glyphicon-trash"
                                    @click="deleteMapping(shippingMethodMapping.shippingMethod.id)"></button>
                        </td>

                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <modal ref="modal">
            <shipping-method-mapping-edit
                    :shippingMethodID="this.shippingMethodMappingModalId"
                    :shopID="this.shopId">
            </shipping-method-mapping-edit>

        </modal>
    </div>
</template>

<script>
    import shippingMethodMappingService from "../../services/shippingMethodMappingService";

    export default {
        name: "ShippingMethodMappingList",
        data() {
            return {
                shippingMethodMappings: [],
                shippingMethodMappingModalId: null,
            }
        },
        props: [
            'shopId'
        ],
        methods: {
            getMappings() {
                shippingMethodMappingService.getByShopId(this.shopId).then(
                    (response) => {
                        this.shippingMethodMappings = response;
                    });
            },

            showModal(shippingMethodId) {
                this.shippingMethodMappingModalId = shippingMethodId;
                this.$refs.modal.id = shippingMethodId;
                this.$refs.modal.show();

            },
            deleteMapping(shippingMethodId) {
                var bestaetigung = window.confirm("sind sie sich sicher das sie das Mapping Löschen wollen? ");
                if (bestaetigung) {
                    shippingMethodMappingService.delete(this.shopId, shippingMethodId);
                }
                this.getMappings();
            }
        },
        mounted() {
            this.getMappings();
            this.$eventBus.$on('shipping-method-mapping-create-edit', () => {
                this.$refs.modal.hide();
                this.getMappings();
            });
        }
    }
</script>

<style scoped>
    .btn-left {
        margin-left: 92%;
    }
</style>